"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = exports.BottomNavLink = exports.NavLink = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var Link_1 = __importDefault(require("../Link"));
var Box_1 = __importDefault(require("../Box"));
exports.NavLink = (0, styled_1.default)(Link_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            color: 'white',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '22px',
            width: 'fit-content',
            padding: '9px 0px'
        },
        _b[theme.mediaQueries.md] = {
            fontSize: '17px',
            fontWeight: 300,
            lineHeight: '24px'
        },
        _b);
});
exports.BottomNavLink = (0, styled_1.default)(Link_1.default)({
    color: 'rgba(255, 255, 255, 0.8)',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '26px'
});
exports.Divider = (0, styled_1.default)(Box_1.default)({
    backgroundColor: 'rgba(210, 210, 210, 0.1)',
    height: '1px',
});
